const Partner = `
  id
  meta
  name
`;

export default Partner;
